// The filter system, in one place. Every recipe declares a category, and any
// number of types, cuisines and traits, each drawn from the lists below. To
// add a filter: add the key and its label here, then tag recipes with it. A
// recipe using a key that isn't listed fails the build, so the catalog can
// never show a chip that leads nowhere, and a typo can never hide a recipe.
//
// Groups combine with AND, values inside a group with OR: picking "Italian"
// and "Mexican" under Cuisine and "Soup" under Type shows Italian or Mexican
// soups. Selections live in the page URL so a filtered view can be shared.

export const FILTERS = {
  category: {
    label: 'Category',
    single: true,
    values: {
      meal: 'Meal',
      snack: 'Snack',
      baked: 'Baked good',
      side: 'Side',
      sauce: 'Sauce',
    },
  },
  types: {
    label: 'Type',
    single: false,
    values: {
      soup: 'Soup',
      stew: 'Stew & chili',
      pasta: 'Pasta',
      'stir-fry': 'Stir-fry',
      bake: 'Bake',
      sandwich: 'Sandwich',
      burrito: 'Burrito & wrap',
      bread: 'Bread',
      muffin: 'Muffins',
      breakfast: 'Breakfast',
      'rice-bowl': 'Rice bowl',
      casserole: 'Casserole',
      quick: 'Quick (under 15 min)',
      taco: 'Tacos',
      waffle: 'Waffles & pancakes',
      'no-bake': 'No-bake',
    },
  },
  cuisines: {
    label: 'Cuisine',
    single: false,
    values: {
      american: 'American',
      italian: 'Italian',
      mexican: 'Mexican',
      chinese: 'Chinese',
      german: 'German',
      mediterranean: 'Mediterranean',
      indian: 'Indian',
      korean: 'Korean',
    },
  },
  traits: {
    label: 'Traits',
    single: false,
    values: {
      'easy-prep': 'Quick & easy',
      'freezer-friendly': 'Freezer-friendly',
      'one-pot': 'One pot',
      'make-ahead': 'Make-ahead',
      'high-protein': 'High protein',
      'hidden-veg': 'Hidden veg',
      bulk: 'Big batch',
      'family-recipe': 'Family recipe',
      'takeout-style': 'Takeout-style',
      'two-in-one': 'Two-in-one',
      'serve-with': 'Serve-with',
      blender: 'Blender',
      'stand-mixer': 'Stand mixer',
      'uses-up-leftovers': 'Uses up leftovers',
    },
  },
} as const;

export type FilterGroup = keyof typeof FILTERS;
export type Category = keyof typeof FILTERS.category.values;
export type RecipeType = keyof typeof FILTERS.types.values;
export type Cuisine = keyof typeof FILTERS.cuisines.values;
export type Trait = keyof typeof FILTERS.traits.values;

export const GROUPS = Object.keys(FILTERS) as FilterGroup[];

export function labelFor(group: FilterGroup, key: string): string {
  const values = FILTERS[group].values as Record<string, string>;
  return values[key] ?? key;
}
